/* global process */

const productionConfig = {
  apiKey: "AIzaSyA_Xeg_R3DsjvPE1xffI3WJC4erqmY-g58",
  authDomain: "all-these-events.firebaseapp.com",
  databaseURL: "https://all-these-events.firebaseio.com",
  projectId: "all-these-events",
  storageBucket: "all-these-events.appspot.com",
  messagingSenderId: "585652776179",
};

const developmentConfig = {
  apiKey: "AIzaSyD-b1eO5TGZdeJmmw4HLjWXBOj4ObUBeLg",
  authDomain: "all-these-events-dev.firebaseapp.com",
  databaseURL: "https://all-these-events-dev.firebaseio.com",
  projectId: "all-these-events-dev",
  storageBucket: "all-these-events-dev.appspot.com",
  messagingSenderId: "190975914682"
};

export const fbConfig = process.env.NODE_ENV === 'production' ? productionConfig : developmentConfig;



// WEBPACK FOOTER //
// ./src/firebase/config.js